import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash'
import axios from 'axios'

Vue.use(Vuex);


const normalizeText = (text) => {
    if (!text) return '';
    return text.toString()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
};

const getAllCatIds = (catId, categories) => {
    let ids = [parseInt(catId, 10)];
    if (!categories || !Array.isArray(categories)) return ids;

    const findCat = (id, cats) => {
        for (let c of cats) {
            if (parseInt(c.id, 10) === parseInt(id, 10)) return c;
            if (c.sublevels && c.sublevels.length > 0) {
                let found = findCat(id, c.sublevels);
                if (found) return found;
            }
        }
        return null;
    };

    let root = findCat(catId, categories);
    if (root) {
        const collectIds = (node) => {
            if (node.sublevels && node.sublevels.length > 0) {
                for (let child of node.sublevels) {
                    ids.push(parseInt(child.id, 10));
                    collectIds(child);
                }
            }
        };
        collectIds(root);
    }
    return ids;
};

const isProductValid = (a) => {
    if (!a) return false;
    if (a.imagenes && Array.isArray(a.imagenes) && a.imagenes.length > 0) {
        return a.imagenes.some(img => {
            let name = typeof img === 'string' ? img : (img && img.nombre);
            return name && name !== 'noimagen' && name.trim() !== '';
        });
    }
    if (a.imagen && typeof a.imagen === 'string' && a.imagen !== 'noimagen' && a.imagen.trim() !== '') {
        return true;
    }
    return false;
};

const applyFilters = (state) => {
    let base = state.products.data || state.products;
    if (!Array.isArray(base)) base = [];

    // 1. Category Filter
    if (state.filterCat) {
        let allowedCatIds = getAllCatIds(state.filterCat, state.categories);
        base = base.filter((a) => {
            if (a.idcategoria && allowedCatIds.includes(parseInt(a.idcategoria, 10))) {
                return true;
            }
            if (a.categorias && Array.isArray(a.categorias) && a.categorias.length > 0) {
                return a.categorias.some(cat => {
                    let catId = parseInt(typeof cat === 'object' ? cat.id : cat, 10);
                    return allowedCatIds.includes(catId);
                });
            }
            return false;
        });
    }

    // 2. Tag Filter
    if (state.filterTag) {
        let tagNorm = normalizeText(state.filterTag);
        base = base.filter((a) => a.etiquetas && normalizeText(a.etiquetas).includes(tagNorm));
    }

    // 3. Search Term (Keyword Search across all fields)
    if (state.searchTerm && state.searchTerm.trim() !== '') {
        let searchNorm = normalizeText(state.searchTerm.trim());
        let words = searchNorm.split(/\s+/).filter(w => w.length > 0);

        base = base.filter((a) => {
            let catNames = '';
            if (a.categorias && Array.isArray(a.categorias)) {
                catNames = a.categorias.map(c => c.nombre || c).join(' ');
            } else if (a.nombre_categoria) {
                catNames = a.nombre_categoria;
            }

            let fullContent = normalizeText([
                a.nombre,
                a.name,
                a.descripcion,
                a.descripcion_corta,
                a.detalle,
                a.codigo,
                a.etiquetas,
                catNames
            ].filter(Boolean).join(' '));

            return words.every(word => fullContent.includes(word));
        });
    }

    state.sorted = base.filter(isProductValid);
};

export const store = new Vuex.Store({
  state: {
    products: [],
    product:{},
    sorted:[],
    productsInCart: [],
    featuredProducts:[],
    min: 1,
    max: 1,

    stock: 1,
    stockMax: 1,

    sliderFilter: [],
    available: true,
    filterCat: null,
    filterTag: null,
    idprod:null,
    categories: [],

    orderPrice:null,
    orderAvailable:null,
    orderQuantity: null,

    searchVisible:false,
    searchTerm:'',

    price:0,
    shipping:0,

    formato:{ style: 'currency', currency: 'USD' },
    dominio: process.env.NODE_ENV === 'production' 
      ? 'https://sistema.empaqueslupa.com' 
      : (typeof window !== 'undefined' && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1'
          ? 'https://sistema.empaqueslupa.com'
          : 'http://127.0.0.1:8000'),
    directory:'shop2',
    configTienda: {
        modo_vista_producto: 'ambos',
        numero_whatsapp: ''
    }
  },

  mutations: {
    setUpConfig(state, config) {
      state.configTienda = Object.assign({}, state.configTienda, config);
    },
    increment(state) {
      state.count++
    },

    setUpProducts(state, products) {
      state.products = products;
      applyFilters(state);
    },
   
    setUpCategories(state, categories) {
      state.categories = categories;
      applyFilters(state);
    },
    setUpCart(state) {
      if (Object.prototype.hasOwnProperty.call(localStorage, 'products')) {
        state.productsInCart = JSON.parse(localStorage.getItem('products'));
      }
    },

    updateProduct(state, value){
      state.product = state.products.filter((a) => a.id==value);
    },
    updateRanges(state, value) {
      state.sliderFilter = [value[0], value[1]];
    },
    updateStock(state, value) {
      state.stock = value;
    },
    updateAvailable(state, value) {
      state.available = value;
    },
    updateFilterCat(state, value) {
      state.filterCat = value;
      applyFilters(state);
    },
    updateFilterTag(state, value) {
      state.filterTag = value;
      applyFilters(state);
    },
    clearCategoryFilter(state) {
      state.filterCat = null;
      applyFilters(state);
    },
    clearAllFilters(state) {
      state.filterCat = null;
      state.filterTag = null;
      state.searchTerm = '';
      applyFilters(state);
    },
    
    updateorderAvaliable(state,value) {
      if(state.available) return;
      state.orderAvailable = value;

      state.sorted = _.orderBy(state.products,'available',value ? 'desc' : 'asc');

      state.orderQuantity = null;
      state.orderPrice = null;
    },
    updateorderPrice(state,value) {
      state.orderPrice = value;
      state.sorted = state.products.filter((a) => a.imagen!='noimagen');
      state.sorted = _.orderBy(state.sorted,'precio_venta',value ? 'desc' : 'asc');

      state.orderQuantity = null;
      state.orderAvailable = null;
    },
    updateorderQuantity(state,value) {
      state.orderQuantity = value;

      state.sorted = _.orderBy(state.products,'stock',value ? 'desc' : 'asc');

      state.orderAvailable = null;
      state.orderPrice = null;
    },
    showSearch(state) {
      state.searchVisible = true;
    },
    hideSearch(state) {
      state.searchVisible = false;
    },
    search(state,value){
      state.searchTerm = value || '';
      applyFilters(state);
    },


    saveToCart(state, payload, wanted = 1) {
      let productToAdd = payload;
      let qty = wanted;

      if (payload && payload.product) {
        productToAdd = payload.product;
        qty = payload.quantity || payload.product.cantidad || wanted;
      } else if (payload && payload.cantidad) {
        qty = payload.cantidad;
      }

      qty = parseInt(qty) || 1;

      // Unique identifier for items with distinct specifications
      let key = productToAdd.cartItemId || (productToAdd.id + '_' + (productToAdd.specs ? JSON.stringify(productToAdd.specs) : ''));
      productToAdd.cartItemId = key;

      let existing = state.productsInCart.find(a => (a.cartItemId || a.id) === key);

      if (existing) {
        existing.wanted = (parseInt(existing.wanted) || 0) + qty;
        existing.cantidad = existing.wanted;
        if (productToAdd.valor_total) {
          existing.valor_total = productToAdd.valor_total;
        }
      } else {
        productToAdd.wanted = qty;
        productToAdd.cantidad = qty;
        state.productsInCart.push(productToAdd);
      }
      this.commit('saveToLocalStorage');
    },
    removeFromCart(state, value) {
      let targetKey = value.cartItemId || value.id;
      state.productsInCart = state.productsInCart.filter((a) => {
        let itemKey = a.cartItemId || a.id;
        return itemKey !== targetKey;
      });

      this.commit('saveToLocalStorage');
    },
    changeQuantity(state, payload) {
      let targetItem = payload.product || payload;
      let newQty = payload.quantity !== undefined ? payload.quantity : (targetItem.wanted || targetItem.cantidad || 1);
      let targetKey = targetItem.cartItemId || targetItem.id;

      if (newQty < 1) return;

      let item = state.productsInCart.find(a => (a.cartItemId || a.id) === targetKey);
      if (item) {
        item.wanted = newQty;
        item.cantidad = newQty;
        if (item.valor_unitario) {
          item.valor_total = item.valor_unitario * newQty;
        }
      }

      this.commit('saveToLocalStorage');
    },
    updatePrice(state,value) {
      state.price = value[0]
      state.shipping = value[1]
    },
    purchase(state) {
      state.productsInCart = []
      this.commit('saveToLocalStorage')
    },
    saveToLocalStorage(state) {
      localStorage.setItem('products', JSON.stringify(state.productsInCart));
    }


  },

  getters: {
    products: state => state.products,
    cart: state => state.cart,
    product:state=>state.product,
    categorias:state=>state.categories,
  },

  actions: {
    getProductosCat(context, id){
      context.commit('updateFilterCat', id)
    },
    setUpStore(context) {
      var url = context.state.dominio + '/api/articulo';
      var url2 = context.state.dominio + '/api/categoria';
      var urlConfig = context.state.dominio + '/api/tienda/configuracion';

      Promise.all([
        axios.get(url2),
        axios.get(url)
      ]).then(([resCats, resProds]) => {
        context.commit('setUpCategories', resCats.data);
        context.commit('setUpProducts', resProds.data.articulos);
      }).catch(err => {
        console.error("Error loading store data:", err);
      });

      axios.get(urlConfig).then(function (response) {
          context.commit('setUpConfig', response.data);
      }).catch(function(err) {
          console.log('No se pudo cargar la configuracion de tienda:', err);
      });

      context.commit('setUpCart');
    },
   
    
  },

})
// store.subscribe((mutation, state) => {
//   // Store the state object as a JSON string
//   console.log(state,mutation)
//   localStorage.setItem('store', JSON.stringify(state));
// });